import gsap from 'gsap';

const desktop_links = document.querySelectorAll('.header__menu .has-children');
const wrappers = document.querySelectorAll('.header__menu .child');

desktop_links.forEach((link, index) => {
  link.addEventListener('mouseenter', () => {
    link.classList.add('is-expanded');

    gsap.fromTo(
      wrappers[index],
      { opacity: 0.2 },
      { opacity: 1, duration: 0.4 }
    );
  });

  link.addEventListener('mouseleave', () => {
    gsap.fromTo(
      wrappers[index],
      { opacity: 1 },
      {
        opacity: 0,
        duration: 0.2,
        onComplete() {
          link.classList.remove('is-expanded');
        },
      }
    );
  });
});
